import { Group, LoadingOverlay } from '@mantine/core';
import React from 'react';
const defaultStyle = {
  margin: '0',
  cursor: 'pointer',
};

const disabledStyle = {
  ...defaultStyle,
  backgroundColor: 'transparent',
  border: 'none',
  color: '#666',
  boxShadow: 'none',
  cursor: 'default',
  opacity: 0.2,
};

interface Props {
  className?: string;
  defaultStyle?: React.CSSProperties;
  disabledStyle?: React.CSSProperties;
  disabled: boolean;
  loading: boolean;
  children: React.ReactNode;
  onClick: () => void;
}

const LoadingButton = (props: Props) => {
  const resolvedDisabledStyle = {
    ...disabledStyle,
    ...props.disabledStyle,
  };
  const resolvedDefaultStyle = { ...defaultStyle, ...props.defaultStyle };
  return (
    <Group style={{ position: 'relative' }}>
      <button
        className={props.className ?? ''}
        disabled={props.disabled}
        onClick={props.onClick}
        style={props.disabled ? resolvedDisabledStyle : resolvedDefaultStyle}
      >
        {props.children}
      </button>
      <LoadingOverlay
        loaderProps={{ color: '#ff00bf', size: 'xs', type: 'bars' }}
        overlayProps={{ backgroundOpacity: 0.0 }}
        visible={props.loading}
      />
    </Group>
  );
};

export default LoadingButton;
